import React from 'react';

interface DefaultAvatarProps {
  size?: number;
}

export const DefaultAvatar: React.FC<DefaultAvatarProps> = ({ size = 48 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#404040"/>
      <mask id={`mask0_avatar_${size}`} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
        <circle cx="24" cy="24" r="24" fill="#D9D9D9"/>
      </mask>
      <g mask={`url(#mask0_avatar_${size})`}>
        <path d="M33 18C33 22.9706 28.9706 27 24 27C19.0294 27 15 22.9706 15 18C15 13.0294 19.0294 9 24 9C28.9706 9 33 13.0294 33 18Z" fill="#ABABAB" fillOpacity="0.8"/>
        <path d="M42 40.5C42 46.299 33.9411 51 24 51C14.0589 51 6 46.299 6 40.5C6 34.701 14.0589 30 24 30C33.9411 30 42 34.701 42 40.5Z" fill="#ABABAB" fillOpacity="0.8"/>
      </g>
    </svg>
  );
};
